import { useEffect, useRef } from "react";
import { warmPrivateFeeProver } from "../../joinsplit-v2/privateFeeProver";

/** Only public parameters are warmed; a used worker is never reused. */
export function useSendPreparationWarmup(enabled: boolean, busy: boolean) {
  const release = useRef<(() => void) | undefined>();
  useEffect(() => {
    if (!enabled) {
      release.current?.();
      release.current = undefined;
    } else if (!busy) {
      release.current?.();
      release.current = warmPrivateFeeProver();
    }
    // Starting a send must preserve its standby worker until it is acquired.
    // The next idle form gets a new worker, including after a failed attempt.
  }, [enabled, busy]);
  useEffect(() => () => release.current?.(), []);
}
